<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, ref, watch } from 'vue';

const numberFormat = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 0, minimumFractionDigits: 0 });
const props = defineProps<{
    userId?: number | null;
    period: string;
}>();

const amount = ref<number | undefined>(undefined);
const amountFormatted = computed(() => amount.value === undefined ? undefined : numberFormat.format(amount.value));

async function loadData(): Promise<void> {
    const response = await axios.get('/stats/quoted_amount', { params: { user_id: props.userId ?? null, period: props.period } });
    amount.value = response.data.amount;
}

onMounted(loadData);
watch(() => [props.userId, props.period], loadData);
</script>

<template>
    <div>
        <p v-if="amount !== undefined">{{ amountFormatted }}</p>
        <div v-else class="spinner-border" role="status"><span class="sr-only">Laddar</span></div>
    </div>
</template>

<style scoped>
p { font-size: 1.5em; }
</style>
